export const FUEL_LIST = [
	{ value: 'Battery Operated', label: 'Battery Operated' },
	{ value: 'CNG', label: 'CNG' },
	{ value: 'Diesel', label: 'Diesel' },
	{ value: 'Diesel Hybrid', label: 'Diesel Hybrid' },
	{ value: 'E-power', label: 'E-power' },
	{ value: 'ELECTRIC', label: 'ELECTRIC' },
	{ value: 'Gasoline', label: 'Gasoline' },
	{ value: 'Gasoline/Hybrid', label: 'Gasoline/Hybrid' },
	{ value: 'Gasoline/Petrol', label: 'Gasoline/Petrol' },
	{ value: 'GF-SXA11G', label: 'GF-SXA11G' },
	{ value: 'Hybrid', label: 'Hybrid' },
	{ value: 'LPG', label: 'LPG' },
	{ value: 'Petrol', label: 'Petrol' },
	{ value: 'PHEV', label: 'PHEV' },
	{ value: 'PHEV Gasoline HYBRID', label: 'PHEV Gasoline HYBRID' }
];
